import { render, staticRenderFns } from "./OddsTable.vue?vue&type=template&id=02cccce3&scoped=true&"
import script from "./OddsTable.vue?vue&type=script&lang=js&"
export * from "./OddsTable.vue?vue&type=script&lang=js&"
import style0 from "./OddsTable.vue?vue&type=style&index=0&id=02cccce3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02cccce3",
  null
  
)

export default component.exports